module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?dfe5aa4344a2d8a29aec8d83fb3fb14e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = r0Cr
// module chunks = 42